var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"title":_vm.$t('condiciones.titulo')}}),_c('FirstBanner'),_c('section',{staticClass:"padding-vertical-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.manager.condiciones_generales)}})])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }